import React from "react";

const BarCounter = () => {
    return (
        <svg width="168" height="55" viewBox="0 0 168 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="154" height="7" transform="matrix(1 0 0 -1 7 7)" fill="#C9D7D8" />
            <rect width="132" height="11" transform="matrix(1 0 0 -1 18 18)" fill="#4A5353" />
            <rect width="125" height="7" transform="matrix(1 0 0 -1 25 25)" fill="#C9D7D8" />
            <path d="M161 0V55C164.866 55 168 51.866 168 48V7C168 3.13401 164.866 0 161 0Z" fill="#C9D7D8" />
            <path d="M150 7V55H161V7L150 7Z" fill="#4A5353" />
            <path d="M143 18V48C143 51.866 146.134 55 150 55V18H143Z" fill="#C9D7D8" />
            <path d="M7 0L7 55C3.13401 55 0 51.866 0 48L0 7C0 3.13401 3.13401 0 7 0Z" fill="#C9D7D8" />
            <path d="M18 7L18 55H7L7 7L18 7Z" fill="#4A5353" />
            <path d="M25 18L25 48C25 51.866 21.866 55 18 55L18 18H25Z" fill="#C9D7D8" />
        </svg>

    )
}
export default BarCounter;